'use client'

import { createContext, useContext, useEffect, useState } from 'react'
import { getDictionary } from '@/lib'
import { DictionaryInterface } from '@/structures/interfaces/DictionaryInterface'

interface BlogDictionaryContextType {
  dict: DictionaryInterface | null
  isLoading: boolean
}

const BlogDictionaryContext = createContext<
  BlogDictionaryContextType | undefined
>(undefined)

export const useBlogDictionary = () => {
  const context = useContext(BlogDictionaryContext)
  if (!context) {
    throw new Error(
      'useBlogDictionary must be used within BlogDictionaryProvider'
    )
  }
  return context
}

export function BlogDictionaryProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [dict, setDict] = useState<DictionaryInterface | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadDict = async () => {
      try {
        const dictionary = await getDictionary('blog')
        setDict(dictionary)
      } finally {
        setIsLoading(false)
      }
    }
    loadDict()
  }, [])

  return (
    <BlogDictionaryContext.Provider value={{ dict, isLoading }}>
      {children}
    </BlogDictionaryContext.Provider>
  )
}
